import type { HttpRequestContext } from '../tql';
import { harRequestToTqlContext } from '../../hooks/api/harRequestToTqlContext';
import type { HARRequest } from '../../hooks/api/mapHarEntryToHarRequest';
import {
  filterRequestsByResponseBodySearch,
  type TrackedHarResponseBodySearchResult,
} from '../../hooks/api/useTrackedHarResponseBodySearch';

export const filterHarRequestsForView = ({
  requests,
  hasActiveFilters,
  responseBodySearch,
  matchesFilters,
}: {
  requests: HARRequest[] | null;
  hasActiveFilters: boolean;
  responseBodySearch: TrackedHarResponseBodySearchResult;
  matchesFilters: (request: HttpRequestContext) => boolean;
}): HARRequest[] | null => {
  if (!requests || !hasActiveFilters) {
    return requests;
  }

  if (responseBodySearch.isActive) {
    return filterRequestsByResponseBodySearch({
      requests,
      search: responseBodySearch,
    });
  }

  return requests.filter((request) =>
    matchesFilters(harRequestToTqlContext(request)),
  );
};
